import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { formatDistanceToNow } from "date-fns";
import en from "date-fns/locale/en-US";
import fr from "date-fns/locale/fr";


interface LastUpdatedTimestampProps {
  updatedDate: Date;
  className?: string;
}

export const LastUpdatedTimestamp = ({
  updatedDate,
  className,
}: LastUpdatedTimestampProps) => {
  const { i18n } = useTranslation();
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [_, setRerenderTrigger] = useState(0);

  useEffect(() => {
    const diffInSeconds = Math.floor((+new Date() - +updatedDate) / 1000);

    let intervalId: any;

    if (diffInSeconds < 3600) {
      intervalId = setInterval(
        () => setRerenderTrigger(prev => prev + 1),
        60_000
      ); // Every minute
    } else if (diffInSeconds < 86400) {
      intervalId = setInterval(
        () => setRerenderTrigger(prev => prev + 1),
        3_600_000
      ); // Every hour
    } else {
      intervalId = setInterval(
        () => setRerenderTrigger(prev => prev + 1),
        86_400_000
      ); // Every 24 hours
    }

    return () => clearInterval(intervalId);
  }, []);

  const formattedTimeDifference = formatDistanceToNow(updatedDate, {
    addSuffix: true,
    // @ts-expect-error - Says type is wrong but looks like it works fine for now
    locale: i18n.language === "fr" ? fr : en,
  });

  return (
    <p
      style={{
        fontSize: 13,
        // fontStyle: "italic",
        textAlign: "right",
        color: "var(--clr-gray-400)",
      }}
      className={className}>
      {formattedTimeDifference}
    </p>
  );
};
